"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DestinationMap = _interopRequireDefault(require("../../DestinationMap/DestinationMap"));
var FlexDestinationMap = function FlexDestinationMap(_ref) {
  var days = _ref.days;
  return /*#__PURE__*/_react["default"].createElement(_DestinationMap["default"], {
    days: days
  });
};
FlexDestinationMap.propTypes = {
  days: _propTypes["default"].array.isRequired,
  routeText: _propTypes["default"].string.isRequired,
  stopType: _propTypes["default"].string,
  title: _propTypes["default"].string
};
var _default = exports["default"] = FlexDestinationMap;